import { authHeader, handleResponse } from '../helpers';
export const IssuedConsumedRptService = {
    fetchFeedbackData
   
};
function fetchFeedbackData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}IssuedConsumedRpt/GetIssuedConsumedReport`, requestOptions)
        .then(handleResponse);
}